import { z } from 'zod';
import { optionalTrimmedNullableEmail, optionalTrimmedNullableString, rejectPhoneContextInjection, requireAtLeastOneField, } from '../zod-helpers/index.js';
import { CONTACT_CONSTRAINTS } from './constraints.js';
import { contactNameSchema, contactPreferredMethodSchema } from './create-input.js';
export const updateContactInputSchema = requireAtLeastOneField(z.object({
    contactName: contactNameSchema.optional(),
    title: optionalTrimmedNullableString(CONTACT_CONSTRAINTS.title.maxLength),
    email: optionalTrimmedNullableEmail(CONTACT_CONSTRAINTS.email.maxLength, `Invalid ${CONTACT_CONSTRAINTS.email.label.toLowerCase()}.`),
    phone: rejectPhoneContextInjection(optionalTrimmedNullableString(CONTACT_CONSTRAINTS.phone.maxLength)),
    preference: contactPreferredMethodSchema.optional().nullable(),
    defaultFlag: z.boolean().optional().nullable(),
}));
//# sourceMappingURL=update-input.js.map